import Image from 'next/image';
import PropTypes from 'prop-types';
import { FiChevronDown } from 'react-icons/fi';
import styled from 'styled-components';

import devices from '@/utilities/devices';

const IntroSectionContainer = styled.section`
  position: relative;
  width: 100%;
  height: fill-available;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content:flex-end;
  align-items: center;
  background: ${props => props.theme.color.black};
  color: ${props => props.isError ? props.theme.color.red : props.theme.color.white};
  z-index: 1;
  img {
    color: transparent;
  }
`;

const Filter = styled.div`
  display: block;
  content: '';
  background-color: rgba(0,0,0, .4);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
`;

const Content = styled.div`
  position: relative;
  display: inline-block;
  text-align: center;
  z-index: 3;
  h1 {
    margin: auto;
    font-size:  ${props => props.isJobOffer ? '2.3em' : props.isSector ? '1.7em' : '2em'};
    font-weight: ${props => props.isJobOffer ? 'bold' : 'normal'};
    letter-spacing: 1px;
    transform: translateY(-4px);
    opacity: 0;
    animation: slideIn .5s ease forwards .1s;

    @keyframes slideIn {
      100% { transform: translateY(0px); opacity: 1;}
    }
  }
  h2 {
    width: ${props => props.isSector && '50%'};
    margin: .8em auto;
    font-size:  ${props => props.isJobOffer ? '1em' : props.isSector ? '1.05em' : '1.25em' };
    color:  ${props => props.isJobOffer && props.theme.color.beige};
    font-weight: 400;
    letter-spacing: 1px;
    transform: translateY(-4px);
    opacity: 0;
    animation: slideIn .5s ease forwards .15s;

    @keyframes slideIn {
      100% { transform: translateY(0px); opacity: 1;}
    }
  }

  @media screen and (${devices.mobile}) {
    h1 {
      width: 90%;
      font-size: 1.7em;
      letter-spacing: 0;
    }
    h2 {
      font-size: 1em;
      width: 90%;
    }
  }
  @media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
    h1 {
      width: 90%;
      font-size: 2.2em;
      letter-spacing: 0;
    }
    h2 {
      font-size: 1.2em;
      width: 85%;
    }
  }

  em {
    font-style: normal;
    border-bottom: 6px solid ${props => {
		switch (props.underlineColor){
			case 'red':
				return props.theme.color.red;
			case 'blue':
				return props.theme.color.blue;
			case 'prune':
				return props.theme.color.prune;
		}
	}};
    @media screen and (${devices.mobile}) {
      border-width: 4px;
    }
  }
`;

const Chevron = styled.div`
  animation: bounce 2s ease infinite .1s;
  @keyframes bounce {
    0% { transform: translateY(0px); }
    25% { transform: translateY(-20px); }
    50% { transform: translateY(-20px); }
    75% { transform: translateY(-20px); }
    100% { transform: translateY(0px); }
  }

  svg {
    font-size: 2.5em;
    text-align: center;
    padding: .2em;
    margin-top: 1.7em;
    cursor: pointer;
    opacity: 0;
    animation : fadeIn 1s ease forwards;
    @keyframes fadeIn {
      100% {opacity: 1;}
    }
  }
`;

const ExtraSpace = styled.div`
  width: 100%;
  height: ${props => props.isJobOffer ? '8.5em' : '6em'};
  background-color: transparent;
  @media screen and (${devices.mobile}) {
    height: ${props => props.isJobOffer ? '9em' : '4em'};
  }
`;

const IntroSection = ({ children, background, isError, underlineColor, scrollTo, isJobOffer, isSector, extraSpace }) => {
	return (
		<IntroSectionContainer isError={isError}>
			{background && (
				<Image
					src={background}
					alt="background intro"
					fill
					style={{ objectFit: 'cover' }}
					priority={true}
					quality={80}
					unoptimized={true}
				/>
			)}
			<Content underlineColor={underlineColor} isJobOffer={isJobOffer} isSector={isSector}>
				{children}
				{(extraSpace) && <ExtraSpace isJobOffer={isJobOffer} />}
				{!isJobOffer && (
					<Chevron>
						<FiChevronDown  onClick={()=>window.scrollTo({ behavior: 'smooth', top: (scrollTo.current.offsetTop - 78) })}/>
					</Chevron>
				)}
			</Content>
			<Filter />
		</IntroSectionContainer>
	);
};

IntroSection.propTypes = {
	children: PropTypes.any,
	background: PropTypes.string,
	isError: PropTypes.bool,
	underlineColor: PropTypes.oneOf(['red', 'blue', 'prune']),
	scrollTo: PropTypes.object,
	isJobOffer: PropTypes.bool,
	isSector: PropTypes.bool,
	extraSpace: PropTypes.bool,
};

export default IntroSection;
